import { Observable } from 'rxjs';

import { ChannelDeverbIntensity, Response } from '@shure/shared/angular/data-access/system-api/models';

import { DeverbChannel } from '../models';

export abstract class DeverbApiService {
	/**
	 * Get channel that supports denoiser.
	 */
	public abstract getChannel$(channelId: string): Observable<DeverbChannel>;

	/**
	 * Enable/disable deverb for channel.
	 */
	public abstract toggleDeverb(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Set deverb intensity level for channel.
	 */
	public abstract setDeverbIntensity(
		channelId: string,
		level: ChannelDeverbIntensity
	): Observable<Response<void, string>>;
}
